const keepKeys = new Set(['id']);

export function logoutCore() {
  // localStorage: keepKeys만 남기고 제거
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (!key) continue;
    if (!keepKeys.has(key)) localStorage.removeItem(key);
  }
  sessionStorage.clear();
}
